import { render } from "./PedidosComponent.vue?vue&type=template&id=e6f93262&scoped=true"
import script from "./PedidosComponent.vue?vue&type=script&lang=js"
export * from "./PedidosComponent.vue?vue&type=script&lang=js"

import "./PedidosComponent.vue?vue&type=style&index=0&id=e6f93262&scoped=true&lang=css"

import exportComponent from "/Users/norberto/Documents/Marketing HL/adminmkthl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6f93262"]])

export default __exports__